import React from 'react';
import { useUpdateAsoScenarioMutation } from '../apiAso';
import EditAsoModal from '../modals/EditAsoModal';

interface EditAsoScenarioModalProps {
  open: boolean;
  asoScenarioId: number;
  currentName?: string;
  onCancel: () => void;
}

const EditAsoScenarioModal: React.FC<EditAsoScenarioModalProps> = ({
  open,
  asoScenarioId,
  currentName,
  onCancel,
}) => {
  const [updateAsoScenario, { isLoading: confirmLoading }] = useUpdateAsoScenarioMutation();

  const modalTitle = `Edit ASO #${asoScenarioId}${currentName ? ` ${currentName}` : ''}`;

  return (
    <EditAsoModal
      open={open}
      currentName={currentName}
      onCancel={onCancel}
      modalTitle={modalTitle}
      formDataType="edit-aso-form"
      formName="edit_aso_modal"
      nameRequiredMessage="Please enter a name for your ASO"
      confirmLoading={confirmLoading}
      onSubmit={name => updateAsoScenario({ id: asoScenarioId, payload: { name } })}
    />
  );
};

export default EditAsoScenarioModal;
